import { Analysis } from 'common-spectrum';
import { hgParseMicromeritics } from 'physical-chemistry-parser';

export function fromMicromeritics(blob) {
  let analysis = new Analysis();
  const parsed = hgParseMicromeritics(blob);

  let meta = {
    ...parsed.meta.header,
    ...parsed.meta.summaryReport,
  };

  meta.cheminfo = { meta: getNormalizedMeta(meta) };

  analysis.pushSpectrum(
    {
      x: {
        data: parsed.variables.C.data,
        label: parsed.variables.C.label,
        units: parsed.variables.C.units,
        type: 'INDEPENDENT',
      },
      y: {
        data: parsed.variables.B.data,
        label: parsed.variables.B.label,
        units: parsed.variables.B.units,
        type: 'DEPENDENT',
      },
    },
    {
      dataType: 'Hg porosimetry',
      title: meta.Sample,
      meta,
    },
  );

  return analysis;
}

function getNormalizedMeta(meta) {
  let result = {};
  const modelKey = Object.keys(meta).filter((key) =>
    key.startsWith('MicroActive'),
  )[0];
  const model = modelKey
    ? modelKey.replace(/^(.*) ([0-9.]*)$/, '$1')
    : undefined;
  const version = modelKey
    ? modelKey.replace(/^(.*) ([0-9.]*)$/, '$2')
    : undefined;
  result.instrument = {
    model,
    manufacturer: 'Micromeritics',
    software: version,
  };
  result.date = meta['HP Analysis Time'];

  result.totalPoreVolume = metaWithUnits(meta, 'Total intrusion volume');
  result.totalPoreArea = metaWithUnits(meta, 'Total pore area');
  result.averagePoreDiameter = metaWithUnits(meta, 'Average pore diameter');
  result.medianPoreVolumeDiameter = metaWithUnits(
    meta,
    'Median pore diameter (volume)',
  );
  result.medianPoreAreaDiameter = metaWithUnits(
    meta,
    'Median pore diameter (area)',
  );
  result.bulkDensity = metaWithUnits(meta, 'Bulk density at');
  result.skeletonDensity = metaWithUnits(meta, 'Apparent (skeletal) density');
  result.porosity = metaWithPercent(meta, 'Porosity');

  return result;
}

function metaWithUnits(meta, metaName) {
  const key = Object.keys(meta).filter((key) => key.startsWith(metaName))[0];
  if (key) {
    let [value, unit] = meta[key].split(' ');
    return {
      value: Number(value),
      units: unit.replace('²', '^2'),
    };
  }
  return undefined;
}

function metaWithPercent(meta, metaName) {
  const key = Object.keys(meta).filter((key) => key.startsWith(metaName))[0];
  if (key) {
    let [value, unit] = meta[key].split(' ');
    if (unit === '%') return Number(value) / 100;
  }
  return undefined;
}
